// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UspSection-UspSection-wrapper-a1624673"};